var docElement = require('./docElement.js');
  /**
   * A convenience helper to check if the document we are running in is an SVG document
   *
   * @access private
   * @returns {boolean}
   */
  var isSVG = docElement.nodeName.toLowerCase() === 'svg';

  module.exports = isSVG;




//////////////////
// WEBPACK FOOTER
// ./node_modules/browsernizr/lib/isSVG.js
// module id = eIlg
// module chunks = 0